// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"466":"3e2beaaf","827":"c9430dcd","964":"3e2beaaf"}[chunkId] + ".chunk.css";
};